/**
 * Review Moderation Service
 * Handles review moderation for admin (approve, reject, pending)
 */

import { logger } from '../../infrastructure/logger';
import { partnerRepository } from '../../data/partnerRepository';

export const reviewModerationService = {
  /**
  * Get pending product reviews (for admin moderation)
  */
  async getPendingProductReviews(): Promise<unknown[]> {
    try {
      return await partnerRepository.getPendingProductReviews();
    } catch (error) {
      logger.error('[ReviewModerationService] Error getting pending product reviews', error);
      return [];
    }
  },

  /**
  * Get pending shop reviews (for admin moderation)
  */
  async getPendingShopReviews(): Promise<unknown[]> {
    try {
      return await partnerRepository.getPendingShopReviews();
    } catch (error) {
      logger.error('[ReviewModerationService] Error getting pending shop reviews', error);
      return [];
    }
  },

  /**
  * Get product reviews by status
  */
  async getProductReviewsByStatus(status: 'pending' | 'approved' | 'rejected'): Promise<unknown[]> {
    try {
      return await partnerRepository.getProductReviewsByStatus(status);
    } catch (error) {
      logger.error(`[ReviewModerationService] Error getting ${status} product reviews`, error);
      return [];
    }
  },

  /**
  * Get shop reviews by status
  */
  async getShopReviewsByStatus(status: 'pending' | 'approved' | 'rejected'): Promise<unknown[]> {
    try {
      return await partnerRepository.getShopReviewsByStatus(status);
    } catch (error) {
      logger.error(`[ReviewModerationService] Error getting ${status} shop reviews`, error);
      return [];
    }
  },

    /**
     * Approve a product review
     */
    async approveProductReview(reviewId: string): Promise<void> {
        try {
            await partnerRepository.approveProductReview(reviewId);
        } catch (error) {
            logger.error('[ReviewModerationService] Error approving product review', error);
            throw error;
        }
    },

    /**
     * Approve a shop review
     */
    async approveShopReview(reviewId: string): Promise<void> {
        try {
            await partnerRepository.approveShopReview(reviewId);
        } catch (error) {
            logger.error('[ReviewModerationService] Error approving shop review', error);
            throw error;
        }
    },

    /**
     * Reject a product review
     */
    async rejectProductReview(reviewId: string, reason?: string): Promise<void> {
        try {
            await partnerRepository.rejectProductReview(reviewId, reason);
        } catch (error) {
            logger.error('[ReviewModerationService] Error rejecting product review', error);
            throw error;
        }
    },

    /**
     * Reject a shop review
     */
    async rejectShopReview(reviewId: string, reason?: string): Promise<void> {
        try {
            await partnerRepository.rejectShopReview(reviewId, reason);
        } catch (error) {
            logger.error('[ReviewModerationService] Error rejecting shop review', error);
            throw error;
        }
    }
};
